import { render, staticRenderFns } from "./RsaPazienteRiunioneEquipeModalEditComponent.vue?vue&type=template&id=fa987c08"
import script from "./RsaPazienteRiunioneEquipeModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiunioneEquipeModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports